import ResizeDiskRequirementsSnippet from "../../../../contents/docs/runbook/snippets/resize-disk-requirements";
import * as React from 'react';
export default {
  ResizeDiskRequirementsSnippet,
  React
};